/* eslint-disable arrow-body-style */
import { TextInput } from '@abyss/web/ui/TextInput';
import React from 'react';
import { ResultsStatus } from '@src/common/types';
import { isFeatureEnabled } from '@src/common/featureFlags/featureFlags';
import {
  linkAnalysisResultsApi,
  useLinkAnalysisResultsStore,
} from '../../mothership/linkAnalysisResults.state';

export const LaGraphSearch = () => {
  const value = useLinkAnalysisResultsStore((state) => state.searchFieldValue);
  const status = useLinkAnalysisResultsStore((state) => state.resultStatus);
  const searchFieldEnabled = isFeatureEnabled('LA_PATH_HIGHLIGHT');

  const clazz =
    status === ResultsStatus.results
      ? 'search-field-visible'
      : 'search-field-hidden';

  return (
    <div className={clazz}>
      {!searchFieldEnabled && <span> </span>}
      {searchFieldEnabled && (
        <TextInput
          value={value}
          onChange={linkAnalysisResultsApi.setSearchValue}
          onClear={linkAnalysisResultsApi.clearSearchValue}
          type="search"
          label="Search Graph"
          hideLabel
          isClearable
        />
      )}
    </div>
  );
};
